var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"root",staticStyle:{"width":"100%"}},[(this.showMessage.length !== 0)?_c('div',{staticClass:"system-message"},[_vm._v(_vm._s(_vm._f("moment")(this.showMessage,"YYYY/MM/DD HH:mm"))+" からメンテナンスです。ご注意ください。")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }